import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaResult from '../../../../components/AccionaResult';

const SuccessPage = ({ formatmsg, customFinishButton }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const pidstring = useLocation().search;
  const centerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '25px',
  };

  return (
    <AccionaResult
      id="succesResult"
      icon={
        <i className="fas fa-check-circle fa-8x" style={{ color: '#82c91e' }} />
      }
      title={intl.formatMessage({ id: formatmsg })}
      className="success"
      extra={[
        <div key="extraSuccess1" className="form-row" style={centerStyle}>
          <AccionaButton
            id="successBtn"
            onClick={() =>
              customFinishButton
                ? // TODO: customFinishButton should not be a function
                  navigate(customFinishButton(), { replace: true })
                : navigate('/ocr' + pidstring, { replace: true })
            }
            msg={intl.formatMessage({ id: 'button.create.end' })}
          />
        </div>,
      ]}
    />
  );
};

SuccessPage.propTypes = {
  formatmsg: PropTypes.string.isRequired,
  customFinishButton: PropTypes.func,
};

SuccessPage.defaultProps = {
  customFinishButton: undefined,
};

export default SuccessPage;
